<template>
    <div class="u-full-height u-flex u-flex-col">
        <div class="row mx-0 mb-24 u-flex--vertical-end">
            <div class="col-12 col-md px-0 mb-18 mb-0@md">
                <h2 class="u-text-normal mb-12">
                    Multi-Upload
                </h2>
            </div>
        </div>

        <form @submit.prevent="onSubmit">
            <div class="form-group">
                <label>Dateien <sup>*</sup></label>
                <drop-file-multiple v-model="files" />
            </div>

            <div>
                <app-button
                    size="small"
                    theme="default"
                    :disabled="isLoading"
                    @click.native="$router.push({ name: 'Home' })">Abbrechen</app-button>

                <app-button
                    ref="submit"
                    size="small"
                    type="submit"
                    class="ml-6"
                    :is-loading="isLoading"
                >Hochladen</app-button>
            </div>
        </form>
    </div>
</template>

<script>
import DropFileMultiple from '@/components/form/DropFileMultiple.vue'
import AppButton from '@/components/ui/Button.vue'

export default {
    name: 'MultiUpload',

    components: { DropFileMultiple, AppButton },

    data: () => ({
        isLoading: false,
        files: [],
    }),

    methods: {
        async onSubmit () {
            try {
                this.isLoading = true

                const formData = new FormData()
                this.files.forEach((file, i) => {
                    formData.append(`file${i}`, file)
                })

                const response = await this.$http.post('/document/batch-upload', formData)

                if (response.data?.error) {
                    throw new Error(response.data.error)
                }

                this.$toast.open({ type: 'success', message: response.data.successHtml })
                await this.$router.push({ name: 'Home' })
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoading = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
